import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Axios from 'axios';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from './';

export const PagesGrid = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageFormInit, setPageFormInit] = useState(null);

    const fetchData = async () => {
        try {
            let dataResponse = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/pages`, {
                params: {
                    filter: {
                        order: 'menuOrder ASC'
                    }
                }
            });
            return dataResponse.data;
        } catch (err) {
            console.log(err);
        }
    }

    const init = async () => {
        setLoading(true);
        let d = await fetchData();
        setData(d);
        setLoading(false);
    }

    const onFormSuccess = async (values) => {
        try {
            if (values.id) {
                let id = values.id;
                delete values.id;
                await Axios.patch(`${process.env.REACT_APP_API_BASE_URI}/api/pages/${id}`, values);
            } else {
                await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/pages`, values);
            }
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    const onDeleteItem = async (id) => {
        try {
            await Axios.delete(`${process.env.REACT_APP_API_BASE_URI}/api/pages/${id}`);
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        init();
    }, []);

    useImperativeHandle(ref, () => ({
        init: init,
        setPageFormInit: setPageFormInit,
    }));

    return (
        <>
            {props.showActions
                ? <Antd.Space
                    style={{
                        marginBottom: 10,
                        float: 'right',
                    }}
                >
                    <Antd.Button
                        icon={<AntdIcons.ReloadOutlined />}
                        title="Reload"
                        disabled={loading}
                        onClick={() => {
                            init();
                        }}
                    />
                    <Antd.Button
                        icon={<AntdIcons.PlusOutlined />}
                        title="Create new"
                        disabled={loading}
                        onClick={() => {
                            setPageFormInit({});
                        }}
                    />
                </Antd.Space>
                : null}
            <Antd.Table
                size={'small'}
                loading={loading}
                dataSource={data}
                rowKey={'id'}
                pagination={{
                    defaultPageSize: 50,
                    showSizeChanger: true,
                }}
            >
                <Antd.Table.Column
                    key='name'
                    dataIndex='name'
                    title='Name'
                    width={200}
                />
                <Antd.Table.Column
                    key='path'
                    dataIndex='path'
                    title='Path'
                />
                <Antd.Table.Column
                    key='roles'
                    dataIndex='roles'
                    title='Roles'
                    width={300}
                    render={(value, record) => (record.roles.map(child => <Antd.Tag>{child}</Antd.Tag>))}
                />
                <Antd.Table.Column
                    key='menu'
                    dataIndex='menu'
                    title='Menu'
                    width={75}
                />
                <Antd.Table.Column
                    key='menuTitle'
                    dataIndex='menuTitle'
                    title='Menu title'
                    width={175}
                />
                <Antd.Table.Column
                    key='menuOrder'
                    dataIndex='menuOrder'
                    title='Menu order'
                    width={75}
                />
                <Antd.Table.Column
                    key='action'
                    title='Action'
                    width={100}
                    render={(value, record) => (
                        <Antd.Space
                            size="middle"
                        >
                            <a
                                onClick={() => {
                                    record.decodedContent = atob(record.content);
                                    setPageFormInit(record);
                                }}
                            >
                                Edit
                            </a>
                            <a
                                onClick={() => {
                                    delete record.id;
                                    record.decodedContent && delete record.decodedContent;
                                    record.name = record.name + ' - copy';
                                    record.path = record.path + '-copy';
                                    onFormSuccess(record);
                                }}
                            >
                                Copy
                            </a>
                            <Antd.Popconfirm
                                placement="topLeft"
                                title="Do you really want to delete the entry?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    onDeleteItem(record.id);
                                }}
                            >
                                <a>
                                    Delete
                                </a>
                            </Antd.Popconfirm>
                        </Antd.Space>
                    )}
                />
            </Antd.Table>
            <Antd.Drawer
                title={pageFormInit && pageFormInit.id
                    ? 'Edit page'
                    : 'Create new page'}
                width={'85%'}
                visible={pageFormInit !== null
                    ? true
                    : false}
                closable={true}
                onClose={() => setPageFormInit(null)}
            >
                {pageFormInit
                    ? <SYS.PageForm
                        initialValues={pageFormInit}
                        onSuccess={onFormSuccess}
                    />
                    : null}
            </Antd.Drawer>
        </>
    )
})